<template>
  <div class="minePage">
    <mythead :userInfo="userInfo"></mythead>
    <div class="column_wrap">
      <router-link to="/userIndex" class="btn flex-rowl">
        <div class="user_icon">
          <van-image
            width="100%"
            height="100%"
            :src="require('../assets/images/user_btn_icon.png')"
          />
        </div>
        个人工作名片
      </router-link>
      <router-link to="/companyIndex" class="btn flex-rowl">
        <i class="iconfont icon-yonghu"></i> 企业/团队管理
      </router-link>
      <router-link to="/mineIndex" class="btn flex-rowl">
        <i class="iconfont icon-anquan"></i> 安全中心
      </router-link>
      <!-- <router-link
        to="/mineIndex/qyWechat"
        class="btn flex-rowl"
        v-if="userAgent != 'other'"
      >
        <div class="qy_icon">
          <van-image
            width="100%"
            height="100%"
            :src="require('../assets/images/qw_logo.png')"
          />
        </div>
        企业微信绑定管理
      </router-link> -->
      <div class="btn flex-rowl" @click="handleExit">
        <i class="iconfont icon-tuichu"></i> 更换账号登录
      </div>
    </div>
  </div>
</template>

<script>
import storage from "../utils/storage";
import Clipboard from "clipboard";
import { mapState } from "vuex";
import mythead from "../components/head.vue";
export default {
  name: "mine",
  components: { mythead },
  data() {
    return {
      userInfo: "",
      cityArea: "",
      checkstate: 0, //0-审核中、1-已通过、2-拒绝加入、3-已退出、4-已被移除
    };
  },
  computed: {
    ...mapState(["OPENID", "USERINFO", "userAgent", "userLoginType"]),
  },
  created() {
    this.getInit();
  },
  methods: {
    async getInit() {
      const toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      // 获取用户
      let res1 = this.$store.state.USERINFO;
      this.userInfo = res1;

      toast.clear();
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$toast.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$toast.fail("复制失败");
        } else {
          this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },

    handleExit() {
      // storage.remove('QYUSERINFOID')
      // storage.remove('USERINFO')
      // storage.remove('OPENID')
      // storage.remove('MENULIST')
      storage.removeAll();
      if (this.userLoginType == 1) {
        this.$router.push("/qyLogin/${userid}/${token}");
      } else {
        this.$router.push("/login");
      }
    },
  },
};
</script>
<style lang="less" scoped>
.minePage {
  padding-bottom: 280px;
  box-sizing: border-box;
  .icon-edit {
    font-size: 30px;
    color: #333;
  }
  .company_column {
    width: 670px;
    margin: 60px auto 0;
    .title {
      padding: 0 20px;
      color: #333333;
      font-size: 30px;
      margin-bottom: 36px;
    }
    .card_box {
      width: 100%;
      box-shadow: 0px 0px 16px 0px rgba(10, 1, 3, 0.1);
      border-radius: 50px;
      background: #fff;
      box-sizing: border-box;
      font-size: 28px;
      color: #333333;
      position: relative;
      .no {
        padding: 92px 0;
        .custom_btn {
          width: 310px;
          margin: auto;
          font-size: 22px;
          &:last-child {
            margin-top: 70px;
          }
        }
      }
      .company_wrapper {
        padding: 50px 35px 50px;
        box-sizing: border-box;
        position: relative;
        font-size: 24px;
        .primary-button {
          height: 60px;
          line-height: 60px;
          font-size: 24px;
          margin: 50px auto;
        }
        .company_upper {
          .img_box {
            width: 160px;
            height: 160px;
            margin-right: 30px;
          }
          .intro {
            font-size: 24px;
            color: #333333;
            .row:nth-child(1) {
              margin-bottom: 22px;
            }
            .subTit {
              font-size: 20px;
              color: #969696;
              margin-bottom: 10px;
            }
          }
        }
        .company_content_info,
        .company_down,
        .company_address {
          margin: 50px 0 85px;
          .row {
            margin-bottom: 28px;
            &:last-child {
              margin-bottom: 0;
            }
            .right {
              flex: 1;
              flex-shrink: 0;
            }
            .bottom {
              margin-top: 10px;
            }
            .place {
              width: 100%;
            }
          }
        }
        .certification_state {
          position: absolute;
          top: 20px;
          right: 15px;
          background: #bebebe;
          border-radius: 17px;
          color: #fff;
          font-size: 18px;
          height: 35px;
          line-height: 35px;
          padding: 0 28px 0 21px;
          &::before {
            display: inline-block;
            content: "";
            background: url(../assets/images/company_auth_icon.png) no-repeat
              center;
            background-size: cover;
            width: 20px;
            height: 20px;
          }
          margin-right: 5px;
        }
        .place {
          font-size: 22px;
          color: #969696;
        }
        .operation {
          position: absolute;
          bottom: -20px;
        }
      }
      .custom_btn {
        height: 60px;
        line-height: 60px;
        padding: 0 35px 0 36px;
        box-sizing: border-box;
        width: auto;
        margin-right: 15px;
        .icon-xinjian {
          font-size: 34px;
          margin-left: 7px;
        }
        .icon-xingtuxuetang-jiaru- {
          font-size: 30px;
          margin-left: 7px;
        }
        .icon-tuichu {
          font-size: 24px;
          margin-left: 7px;
          font-weight: bold;
        }
      }
    }
  }
  .column_wrap {
    .btn {
      width: 600px;
      height: 110px;
      border: 1px solid #aaaaaa;
      font-size: 28px;
      color: #333333;
      margin: 0 auto 50px;
      padding-left: 155px;
      box-sizing: border-box;
      &:last-child {
        margin-top: 100px;
      }
      .user_icon {
        width: 34px;
        height: 35px;
        margin-right: 18px;
      }
      .qy_icon {
        width: 43px;
        height: 35px;
        margin-right: 18px;
      }
      .iconfont {
        margin-right: 20px;
      }
      .icon-anquan {
        font-size: 44px;
      }
      .icon-yonghu {
        font-size: 36px;
      }
      .icon-tuichu {
        font-size: 40px;
        font-weight: 600;
      }
    }
  }
}
</style>
